import {Injectable, Host, OnDestroy, OnInit} from '@angular/core';
import {DirectoryItemComponent} from './directory-item.component';
import {ApiService} from '../../services/api-directory.service';
import {DirectoryService} from '../../services/directory.service';
import {ConstantsService} from '../../services/constants.service';

declare const swal: any;
declare const toastr: any;
declare const moment: any;

@Injectable()
export abstract class AbstractView implements OnInit, OnDestroy {
    public id: number;
    public data: any;
    public title = '';

    public isCreateModal = false;

    constructor(@Host() public parent: DirectoryItemComponent,
                public api: ApiService,
                public directoryService?: DirectoryService) {
    }

    ngOnInit(): void {
        this.api.getItemId(this.parent).subscribe((id) => {
            if (id) {
                this.getData(id);
            }
        });
        if (this.directoryService)
            this.directoryService.onUnitChangeCompleted.subscribe(response => this.updateView());
    }

    create(): void {
        this.showModal();
    }

    updateView(isRedirect: boolean = true): void {
        this.api.updateView(this.parent, isRedirect);
    }

    public showModal(): void {
        this.isCreateModal = true;
    }

    public hideModal(): void {
        this.isCreateModal = false;
        this.updateView(false);
    }

    update(data: any): void {
        this.api.updateItem(this.id, data).subscribe(
            (res) => {
                if (res.user) this.getData(res.user);
                // this.updateView(false)
            },
            (error) => {
                if (error._body) {
                    const body = JSON.parse(error._body);
                    if (body.errors && body.errors.length > 0) {
                        body.errors.forEach(error => {
                            if (error.error == 'error.constraint.error.email.email_exists_for_building_and_suite.archived')
                                this.directoryService.restoreResident(this.data.suiteUser[0].suite.id, data.email);
                        });
                    }
                }
                this.directoryService.api.errorHandler(error, 'Update failed!');
            }
        );
    }

    remove(): void {
        swal({
                title: 'Delete ' + this.title,
                text: 'Are you sure you want to delete?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                closeOnConfirm: true
            }, () => {
                this.api.deleteItem(this.id).subscribe(() => {
                    this.updateView();
                });
            }
        );

    }

    public getData(id: number): void {
        this.data = null;
        this.parent.spinnerShow = true;
        this.api.getItem(id).subscribe((res) => {
            this.data = res;
            this.parent.spinnerShow = false;
            if (this.data) {
                if (this.data.suiteUser) {
                    this.id = this.data.suiteUser[0].id;
                    this.data.groups = res.groups.map(item => ({id: item.group.id, itemName: item.group.name}));
                    this.directoryService.getResidentInstructions(this.data.id);
                    if (this.data.alternativeEmails.length) {
                        this.getAlternativeEmails(this.id);
                    }
                } else {
                    this.id = this.data.id;
                }
            } else {
                throw new Error('Can\'t find suiteUser id');
            }
        }, err => this.parent.spinnerShow = false);
    }

    getAlternativeEmails(suiteUserId) {
        const url = `/v1/suite-users/${suiteUserId}.json?expand=user.alternativeEmails`;
        this.directoryService.api.get('domainBD', `${url}`)
            .subscribe(
                (res) => {
                    const body = JSON.parse(res._body);
                    this.data.alternativeEmails = body.user.alternativeEmails;
                },
                (error) => {
                    console.warn('ResidentsComponent -> AbstractView -> getAlternativeEmails -> error', error);
                }
            );

    }

    updateNameInList(list: string, petId: string, field: string, fieldValue: string): void {
        const item = this.parent[list].find(i => i.id === petId);
        if (item) item[field] = fieldValue;
    }

    moveOut(type) {
        swal(ConstantsService.getSwalConfig('Are you sure?', `You want to move this ${type} out today?`),
            () => {
                const data = {moveOutDate: moment().format('YYYY-MM-DD')};
                this.api.updateItem(this.id, data).subscribe(
                    res => this.getData(this.id),
                    error => this.parent.directoryService.api.errorHandler(error, 'Failed to restore.')
                );
            }
        );
    }

    restore() {
        const data = {moveOutDate: null};
        this.api.updateItem(this.id, data).subscribe(
            res => this.getData(this.id),
            error => this.parent.directoryService.api.errorHandler(error, 'Failed to restore.')
        );
    }

    convertDate(date) {
        return date ? moment(date).format('YYYY-MM-DD') : '';
    }

    ngOnDestroy(): void {
        if (this.directoryService)
            this.directoryService.onUnitChangeCompleted.observers = [];
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/directory-item/abstract-view.class.ts